import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
    height: fit-content;
    text-align: center;
    padding: 20px;

    h1{
        margin: 20px;
        font-size: 2rem;
        text-transform: uppercase;
    }

    p{
        display: block;
        width: 90%;
        margin: 20px auto;

        @media (min-width: 1100px){
            width: 30%;
        }
    }

    form{
        margin-top: 40px;

        @media (min-width: 1100px){
            width: 60%;
            margin: 0 auto;
        }

        label{
            float: left;
            margin: 20px auto;
        }

        input{
            width: 100%;
            height: 38px;
            padding-left: 10px;
            outline: none;
        }

        textarea{
            width: 100%;
            height: 150px;
            padding-left: 10px;
            outline: none;
        }

        button{
            width: 200px;
            padding: 10px 0;
            margin: 30px;
            border-radius: 50px;
            background: #26a6d1;
            color: #fff;
            border: none;
            text-transform: uppercase;

            &:hover{
                background: #0a556e;
            }
        }
    }
`